export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/table.worker.dc6d8d8c.worker.js");
}
